module.exports = __webpack_public_path__ + "img/info-hexagon.f4a7bd23.svg";